import { AuthApiClient } from '@guiker/propsharing-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useAuthApiClient = useAuthenticatedApiClient(AuthApiClient)
